import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ProjectSelector from '../components/project-selector';
import { TENANT } from '../constants';
import { resetProject, switchProject } from '../sub-projects/tenant/actions/project';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class MainProjectSelector extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <ProjectSelector
            projects={this.generateTenants()}
            onProjectChange={this.switchProject} />
      </div>
    );
  }
  private generateTenants = () => {
    const result = [{
      value: TENANT.NO_TENANT,
      label: TENANT.NO_TENANT_NAME
    }];
    result.push(...this.props.app.projects.map(p => ({
      value: p.id, label: p.Subdomain
    })).sort(v => v.Subdomain));
    return result;
  }
  private switchProject = (id: string, name: string) => {
    if (TENANT.NO_TENANT === id) {
      this.props.dispatch(resetProject());
      this.props.history.push('/console/tenants');
    } else {
      this.props.dispatch(switchProject(this.props.authentication.session.id, id, name))
      this.props.history.push('/console/tenants/' + id);
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(MainProjectSelector)));



// WEBPACK FOOTER //
// ./src/containers/main-project-selector.tsx